/*
 * @Author: wankong
 * @Desc:
 * @Date: 2021-12-09 21:15:12
 * @LastEditTime: 2022-01-09 14:23:54
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import dialog from "./components/common/Toast/index";
import loading from "./components/common/Loading/index";
import lazyLoad from "./directives/lazyLoad";

import "./utils/filter.js";
import "./common/common.css";
import "./common/iconfont.css";
import utils from "@/utils/utils.js";
Vue.config.productionTip = false;
Vue.prototype.$utils = utils;
Vue.use(dialog);
Vue.use(loading);
// directives
Vue.use(lazyLoad);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
